import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import HighLevelKpis from "./HighLeveKpis/HighLevelKpis";
import Acquisition from "./Acquisition/Acquisition";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import RevenueStreams from "./RevenueStreams/RevenueStreams";
import {
  typography,
  colors,
} from "../../../../../../../../assets/styles/tokens";
import EfficiencyMetrics from "./EfficiencyMetrics/EfficiencyMetrics";
import PlayerValue from "./PlayerValue/Playervalue";
import KpiRRfilter from "./KpiRRFilter/KpiRRfilter";

const KpiandBr = () => {
  return (
    <Box sx={{ px: 2 }}>
      <KpiRRfilter />
      <Stack>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.Font_weight.Medium.$value,
              color: colors.GrayLightMode[900].$value,
              mb: 1.5,
            }}
          >
            High Level KPI’s
          </Typography>
          <HighLevelKpis />
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.Font_weight.Medium.$value,
              color: colors.GrayLightMode[900].$value,
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            Acquisition
            <EmojiObjectsOutlinedIcon
              sx={{
                fontSize: typography.Size.Text.lg.$value,
                color: colors.GrayLightMode[700].$value,
              }}
            />
          </Typography>
          <Acquisition />
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.Font_weight.Medium.$value,
              color: colors.GrayLightMode[900].$value,
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            Revenue Streams
            <EmojiObjectsOutlinedIcon
              sx={{
                fontSize: typography.Size.Text.lg.$value,
                color: colors.GrayLightMode[700].$value,
              }}
            />
          </Typography>
          <RevenueStreams />
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.Font_weight.Medium.$value,
              color: colors.GrayLightMode[900].$value,
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            Efficiency Metrics
            <EmojiObjectsOutlinedIcon
              sx={{
                fontSize: typography.Size.Text.lg.$value,
                color: colors.GrayLightMode[700].$value,
              }}
            />
          </Typography>
          <EfficiencyMetrics />
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: typography.Font_weight.Medium.$value,
              color: colors.GrayLightMode[900].$value,
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            Player Value
            <EmojiObjectsOutlinedIcon
              sx={{
                fontSize: typography.Size.Text.lg.$value,
                color: colors.GrayLightMode[700].$value,
              }}
            />
          </Typography>
          <PlayerValue />
        </Box>
      </Stack>
    </Box>
  );
};

export default KpiandBr;
